module.exports = __webpack_public_path__ + "img/1576290207.242dca19.jpg";